module.exports = __webpack_public_path__ + "static/media/almofada2.73a83e31.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/almofada2.png
// module id = 49
// module chunks = 0